module.exports = __webpack_public_path__ + "img/tile-fnb3.ea79808c.jpg";